import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccordionComponent, AccordionPanelComponent } from 'ngx-bootstrap/accordion';
import { JsonExpenseModel } from '../../../models/low-level/expense.model';
import { JsonTimesheetNotificationModel } from '../../../models/low-level/timesheet-notification.model';
import { JsonTimesheetEntryModel } from '../../../models/complex/timesheet-entry.model';
import { formatTextModel } from '../pace-spector.utils';

@Component({
    selector: 'pace-core-notification-spector',
    imports: [CommonModule, AccordionPanelComponent, AccordionComponent],
    templateUrl: './notification-spector.component.html',
    styleUrl: './notification-spector.component.css',
})
export class NotificationSpectorComponent {
    public notification = input.required<JsonTimesheetNotificationModel>();

    public entries = computed<JsonTimesheetEntryModel[]>(() => this.notification().timesheetEntries ?? []);
    public expenses = computed<JsonExpenseModel[]>(() => this.notification().expenses ?? []);
    public distanceText = computed(() => formatTextModel(this.notification().distance));

    public title = computed(() => {
        const n = this.notification();
        const id = n.notificationId?.frontId || 'no frontid';
        const notificationNumber = n.notificationId?.qmNum ? ` :: Notification ${n.notificationId.qmNum}` : '';
        const taskNumber = n.notificationId?.maNum ? ` :: Task ${n.notificationId.maNum}` : '';
        const cust = n.customerName ? ` :: ${n.customerName}` : '';
        const dist = formatTextModel(n.distance) ? ` :: ${formatTextModel(n.distance)}` : '';
        return `[${id}]${notificationNumber}${taskNumber}${cust}${dist}`;
    });
}
